import { createReducer, on } from '@ngrx/store';
import { ActiveComponentChanged } from 'src/app/shared/actions/eliqua.actions';
import {
  CreateSecurityGroup,
  EditSecGroup,
  PoliciesSearchFilterChanged,
  PolicyInDocumentChanged,
  RemovePolicyDoc,
  RemoveUser,
  SecGroupDescriptionChanged,
  SecGroupNameChanged,
  UserInGroupChanged,
  UsersSearchFilterChanged,
  UserSubmitted,
} from '../actions/security-groups.actions';
import { CloseSidenav } from '../actions/side-nav.actions';
import {
  GetPolicyDocumentsSuccess,
  GetSecGroupsSuccess,
  GetSecGroupSuccess,
} from '../actions/user-search.actions';
import { SecurityGroupsState } from '../models/user.models';

const initialState: SecurityGroupsState = {
  groups: '',
  groupInEdit: '',
  groupName: '',
  groupDescription: '',
  docsInGroup: [],
  addDocsInGroup: [],
  policyDisplayedColumns: [],
  usersInGroup: [],
  addUsersInGroup: [],
  usersDisplayedColumns: {},
  searchFilterPolicies: '',
  searchFilterUsers: '',
  submit: false,
  createNewSecurityGroup: false,
};

export const SecurityGroupsReducer = createReducer(
  initialState,
  on(GetPolicyDocumentsSuccess, (state, { res }) => {
    let addDocsInGroup = {};
    res.map((policy: any) => {
      Object.assign(addDocsInGroup, { [policy.policyDocumentId]: policy.policyDocumentName });
    });

    return {
      ...state,
      addDocsInGroup,
      policyDisplayedColumns: ['PolicyName', 'Delete'],
      usersDisplayedColumns: {
        UserName: 'userName',
        DisplayedName: 'displayedName',
        Delete: 'delete',
      },
    };
  }),
  on(CreateSecurityGroup, (state) => ({
    ...state,
    createNewSecurityGroup: true,
  })),
  on(GetSecGroupsSuccess, (state, { res }) => {
    let addUsersInGroup: string[] = [];
    res.map((group: any) =>
      group?.securityGroupAppUsers?.map((secGroup: any) => {
        if (!(secGroup.userName in addUsersInGroup)) addUsersInGroup.push(secGroup.userName);
      }),
    );
    return {
      ...state,
      groups: res,
      addUsersInGroup,
    };
  }),
  on(GetSecGroupSuccess, (state, { res }) => ({
    ...state,
    groups: state.groups.map((secGroup: any) =>
      secGroup.securityGroupId === res.securityGroupId ? res : secGroup,
    ),
  })),
  on(SecGroupNameChanged, (state, { groupName }) => ({
    ...state,
    groupName,
  })),
  on(SecGroupDescriptionChanged, (state, { groupDescription }) => ({
    ...state,
    groupDescription,
  })),
  on(EditSecGroup, (state, { row }) => {
    let docsInGroup: string[] =
      Object.values(
        state.groups.find((group: any) => group.securityGroupName === row.securityGroupName)
          ?.policyDocumentsMap,
      ) ?? null;
    if (docsInGroup) docsInGroup.sort();
    return {
      ...state,
      groupInEdit: row,
      docsInGroup,
      groupName: row.securityGroupName,
      usersInGroup: [...row.securityGroupAppUsers].sort((groupPrev: any, groupNext: any) => {
        return groupPrev.userName.localeCompare(groupNext.userName);
      }),
      groupDescription: row.securityGroupNotes ? row.securityGroupNotes : '',
    };
  }),
  on(PolicyInDocumentChanged, (state, { policy }) => {
    let docsInGroup = [...state.docsInGroup];
    if (policy && !docsInGroup.includes(policy)) {
      docsInGroup = [...docsInGroup, policy];
    }

    return { ...state, docsInGroup };
  }),
  on(UserInGroupChanged, (state, { user }) => {
    let usersInGroup = [...state.usersInGroup];
    let newUser: any = {};
    state.groups.find(
      (userGroups: any) =>
        (newUser = userGroups.securityGroupAppUsers.find((group: any) => group.userName === user)),
    );
    usersInGroup = [...usersInGroup, newUser];
    return { ...state, usersInGroup };
  }),
  on(RemovePolicyDoc, (state, { policyDoc }) => ({
    ...state,
    docsInGroup: state.docsInGroup.filter((currPolicyDoc: string) => currPolicyDoc !== policyDoc),
  })),
  on(RemoveUser, (state, { user }) => ({
    ...state,
    usersInGroup: state.usersInGroup.filter((currUser: any) => currUser.userName !== user),
  })),
  on(PoliciesSearchFilterChanged, (state, { searchFilterPolicies }) => ({
    ...state,
    searchFilterPolicies,
  })),
  on(UsersSearchFilterChanged, (state, { searchFilterUsers }) => ({
    ...state,
    searchFilterUsers,
  })),
  on(UserSubmitted, (state) => ({
    ...state,
    submit: true,
  })),
  on(CloseSidenav, (state) => ({
    ...state,
    groupInEdit: '',
    groupName: '',
    groupDescription: '',
    docsInGroup: [],
    usersInGroup: [],
    searchFilterPolicies: '',
    searchFilterUsers: '',
    submit: false,
    createNewSecurityGroup: false,
  })),
  on(ActiveComponentChanged, (state) => ({
    ...state,
    groupInEdit: '',
    groupName: '',
    groupDescription: '',
    docsInGroup: [],
    usersInGroup: [],
    searchFilterPolicies: '',
    searchFilterUsers: '',
    submit: false,
    createNewSecurityGroup: false,
  })),
);
